import { useRef } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import {
  FloatingLabel,
  Form,
  Row,
  Button as BSButton,
  Col,
} from "react-bootstrap";
import {ServiceModel } from "../../../data/entities";
import {
  Button,
  SlideOutModal,
  SlideOutModalProps,
  SearchableLocationDropdown,
  HandleDropDownListChange,
} from "../../../components";
import { userHasRoles } from "../../../components/AppSidebar/hooks";
import { useSelector } from "react-redux";
import { get } from "http";
import { getUserInfo } from "../../../app";

export interface AddAllServiceModalProps extends SlideOutModalProps {
  service?: ServiceModel;
  onSubmit: any;
}

export function AddAllServiceModal(props: Readonly<AddAllServiceModalProps>) {
  const submitRef = useRef<HTMLButtonElement>(null);
  const validationSchema = yup.object().shape({
    locationId: yup.number().required("Location is required"),
  });

  const location = useSelector(getUserInfo())?.locationIds ?? [];
 
  return (
    <SlideOutModal
      {...props}
      title={`Add All Services To Location`}
      footer={
        <div className="container p-0">
          <div className="row g-0">
            <div className="col-12 pe-2">
              <Button
                onClick={() => props.showState.setter(false)}
                variant="cancel"
                className="w-100"
              >
                Cancel
              </Button>
            </div>
            <div className="col-12 ps-2">
              <Button
                onClick={() => {
                  submitRef.current?.click();
                }}
                variant="primary"
                className="w-100"
              >
                Add
              </Button>
            </div>
          </div>
        </div>
      }
    >
      <Formik
        validationSchema={validationSchema}
        initialValues={{
          locationId: null,
        }}
        onSubmit={async (values) => {
          props.onSubmit({
            ...values,
          });
          props.showState.setter(false);
        }}
      >
        {({ values, handleSubmit, setFieldValue, touched, errors }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <Form.Group controlId="locationId">
                    <SearchableLocationDropdown
                      defaultItem={true}
                      filterLocation={location}
                      name="locationId"
                      value={values.locationId}
                      onChange={(e) =>
                        HandleDropDownListChange(e, setFieldValue)
                      }
                      isInvalid={touched.locationId && !!errors.locationId}
                    >
                      <Form.Control.Feedback type="invalid">
                        {errors.locationId}
                      </Form.Control.Feedback>
                    </SearchableLocationDropdown>
                  </Form.Group>
                </Col>
              </Row>
              <BSButton ref={submitRef} type="submit" className="d-none" />
            </Form>
          );
        }}
      </Formik>
    </SlideOutModal>
  );
}

export default AddAllServiceModal;
